// @flow

import { useTranslator } from '@gandi/translate';
import { Button } from '@gandi/ui';

type Props = { fqdn: string };

export function RegisterButton({ fqdn }: Props): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <Button to={`/domain/suggest?search=${fqdn}`}>{__('Register')}</Button>
  );
}
